export const ToastSuccess: ToastLevel = 'success';
export const ToastError: ToastLevel = 'error';
export const ToastInfo: ToastLevel = 'info';
export const ToastWarning: ToastLevel = 'warning';

export type ToastLevel = 'success' | 'error' | 'info' | 'warning';
